import { render, staticRenderFns } from "./ModalCatalogCategoryFilterSetting.vue?vue&type=template&id=1f8be9a3&"
import script from "./ModalCatalogCategoryFilterSetting.vue?vue&type=script&lang=js&"
export * from "./ModalCatalogCategoryFilterSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports